

export function generateStandardEmailClosingPlainText(): string {

  let emailBodyPlainText = `Sincerely,\n`;

  emailBodyPlainText += `Your friends at %PROJECT_NAME%\n\n`;

  emailBodyPlainText += `(This email has been sent from an unmonitored email address. If you require support, please email to support@mydigibrain.com.)\n\n`;

  emailBodyPlainText += `%PROJECT_NAME% Copyright (c) 2020-${new Date().getFullYear()}.\n\n`;

  return emailBodyPlainText;
}
